import { Cookies } from 'react-cookie';
import { LOGOUT } from './auth';

const authErrors = [401, 403];

export default () => () => (next) => (action) => {
  if (!action) {
    return null;
  }

  if (action.error) {
    const error = action.payload;
    if (authErrors.includes(error.status)) {
      const cookies = new Cookies();
      cookies.remove('nuk_pc');
      next({
        type: LOGOUT
      });
    }
  }
  return next(action);
};
